import { AnalyticsEvent, TelemetryEvent } from './types';

export const isAnalyticsEvent = (event: TelemetryEvent): event is AnalyticsEvent => event.type === 'Analytics';
